import { createSvgIcon } from '@mui/material/utils'

const SuccessPlate = createSvgIcon(
  <>
    <path
      d="M11.13 31.86H73.79C73.79 34.04 72.02 35.8 69.85 35.8H15.08C12.9 35.8 11.14 34.03 11.14 31.86H11.13Z"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M25.62 35.8L37.36 54.9L42.53 66.96C42.53 66.96 51.61 65.86 55.68 60.23L54.11 56.94C54.11 56.94 57.55 51.77 57.71 40.97C57.71 40.97 58.98 38.75 62.1 37.01C61.5 36.25 60.58 35.81 59.62 35.81H55.99L49.1 44.03L47.3 44.11L45.66 43.01L43 35.81H39.48L40.42 43.17L32.98 35.81H25.62V35.8Z"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path
      d="M46.36 53.26C46.36 53.26 42.52 48.17 37.36 45.04L29.38 35.8"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path
      d="M54.11 56.94C54.11 56.94 50.97 60.56 46.36 61.96"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path
      d="M55.68 60.23L58.63 66.06L46.22 72.2L43.4 66.82"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path
      d="M63.96 76.25L58.63 66.06L41.85 74.36L42.46 76.24"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path
      d="M15.22 31.8601C15.22 31.8601 12.7 22.5301 23.31 15.8001C34.62 9.65005 44.01 7.34005 48.24 7.16005C52.47 6.99005 56.99 8.67005 59.26 10.7501"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M49.9799 14.12C49.9799 14.12 52.7599 11.28 56.5899 11.69C58.2699 11.81 59.9499 10.3 60.5299 9.78005C61.1099 9.26005 63.8899 7.81005 66.1499 9.78005C68.4099 11.75 67.3699 14.7701 65.3999 16.85C64.6499 17.6 64.2999 19.28 64.2999 20.39C64.2999 21.5 64.1799 27.06 57.2299 28.51C53.9799 28.97 49.6899 25.55 49.6899 25.55"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M69.11 31.86C69.11 31.86 69.52 21.6 65.4 16.84"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M28.58 19.5L29.61 18.97C30.58 18.47 31.76 18.68 32.5 19.48L34.96 22.17L37.15 20.09C38.13 19.16 39.42 18.65 40.77 18.65H41.94C42.51 18.65 42.97 19.11 42.97 19.68C42.97 19.98 42.84 20.26 42.62 20.45L35.58 26.62C34.74 27.36 33.47 27.35 32.63 26.61L28.59 23.02"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M74.7599 3.30003C74.3999 2.94003 73.8799 2.84003 73.4299 2.99003C73.5799 2.54003 73.4799 2.02003 73.1199 1.66003C72.6099 1.15003 71.7799 1.15003 71.2799 1.66003C70.7699 2.17003 70.7699 3.00003 71.2799 3.50003L65.5699 9.21003L67.2099 10.85L72.9199 5.14003C73.4299 5.65003 74.2599 5.65003 74.7599 5.14003C75.2599 4.63003 75.2699 3.80003 74.7599 3.30003V3.30003Z"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path d="M17.06 1.21002L18.86 10.92" stroke="#204ECF" strokeLinejoin="round" />
    <path d="M13.23 12.21L0.340027 0.369995" stroke="#204ECF" strokeLinejoin="round" />
    <path d="M11.37 18.65L2.19 16.42" stroke="#204ECF" strokeLinejoin="round" />
  </>,
  'SuccessPlate'
)

export default SuccessPlate
